import { Query } from '@apollo/client/react/components';
import {
  getTranslatedText,
  AccessControl,
  getHeaderValue,
  getEntityAttributes,
  ENTITY_MAP,
  TEXT_LENGTH,
  fetchApi,
  COMMON_CONSTANTS
  // withErrorBoundary
} from '@nile/components';
import { GET_PUBLISHED_TICKET_FORMS } from '@nile/graphql';
import {
  DualCell,
  ClientSelect,
  UserSelect
} from '@nile/mangifera/src/Components/Ticket';
import { CustomFormTemplate } from '@nile/mangifera/src/Containers/FormContainers';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import { TextField, Spinner, Badge } from '@superops/ui-design-system';
import { Avatar } from '@shopify/polaris';
import {
  getAccessor,
  getCellType,
  getDependantField,
  getParentField,
  isDependantField
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import dompurify from 'dompurify';
import { cloneDeep, isEmpty, sortBy } from 'lodash';
import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import SiteSelect from '@nile/projects/src/Components/Inputs/SiteSelect';
import { DepartmentSelect } from '@nile/itsm/src/pages/components/DepartmentSelect';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import withErrorBoundary from '../../../../components/src/HOC/withErrorBoundary';
import { SVGIcon } from '@superops/super-icons';

const Wrapper = styled.div`
  .formTemplates .Polaris-Avatar__Image {
    width: 20px;
    height: 20px;
    background: #afcf8d;
  }
  .formTemplates .Polaris-Avatar--hasImage {
    background: #afcf8d;
  }
  .source {
    border-bottom: 1px solid #ececec;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
  }
  .subject-wrapper {
    padding: 0 20px;
  }
  .subject-wrapper .Polaris-TextField__Backdrop {
    border-bottom: none;
  }
  .editor-holder {
    padding: 0 20px;
    padding-bottom: 2rem;
  }
  .Header-Input {
    max-width: 100% !important;
    margin-left: 20px;
  }
  .technician-select .Polaris-Avatar {
    margin-left: 8px;
    background: linear-gradient(180deg, #88f0ff 0%, #75a6ff 97.04%);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
  }
  .pageAct {
    flex-grow: 1;
    justify-content: center;
  }

  .custom-form-layout {
    width: 100%;
    border: none;
  }

  .custom-form-layout-card {
    height: 100%;
    padding: 0 20px;
    border-top: 1px solid #ececec;
    padding-top: 2rem;
  }
  .react-grid-layout {
    border: none;
    width: 100% !important;
  }

  .actionsWrapper {
    border-bottom: 1px solid #ececec;
  }
  .rdw-editor-wrapper {
    height: auto !important;
    display: flex;
    background: #ffffff;
    flex-direction: column-reverse;
    margin: 2px;
  }

  .TabPage {
    justify-content: center;
    overflow: auto;
    height: calc(100% - 180px);
  }
  .value_selector__control {
    min-width: 160px;
  }
  .value_selector__menu {
    z-index: 21;
  }
`;

const TechCell = styled.div`
  .closeIcon {
    visibility: hidden;
    position: relative;
    top: 3px;
    right: 20px;
  }

  &:hover {
    .closeIcon {
      visibility: visible;
    }
  }
`;

const Field = styled.div`
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;

const EditorHolder = styled.div`
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
          padding: 12px 20px;
        }
        .ql-editor.ql-blank::before {
          left: 20px;
        }
      }
    }

    .ql-toolbar {
      border: none;
    }
  }
`;

const formInputKeys = [
  'status',
  'priority',
  'impact',
  'urgency',
  'category',
  'subcategory',
  'cause',
  'subcause',
  'resolutionCode',
  'customFields',
  'ticketType'
];
class CreateTicketForm extends Component {
  // componentWillUnmount() {
  //   EventEmitter.unsubscribe('tabChange');
  // }

  constructor(props) {
    super(props);
    this.state = {
      ticketMeta: []
    };
  }

  componentDidMount() {
    const { entitiesMeta } = this.props;
    const allEntityFields = getEntityAttributes(
      entitiesMeta,
      ENTITY_MAP.ticket
    );
    this.setState({ ticketMeta: allEntityFields });
  }
  updateTabState = (eventData) => {
    this.props.context.updateTabState(
      {
        ticket: this.props.state.ticket,
        selectedFormTemplate: this.props.state.selectedFormTemplate,
        template: this.props.state.template
      },
      eventData
    );
  };

  getNestedChilds = (currentField, meta) => {
    const nestedChild = [];
    if (currentField?.nestedAttributes) {
      const getChilds = (fld) => {
        fld?.nestedAttributes?.map((el) => {
          const child = meta?.find((attr) => attr?.name === el);
          if (child) {
            nestedChild.push(child);
            if (child?.nestedAttributes) {
              getChilds(child);
            }
          }
        });
      };
      getChilds(currentField);
    }
    return nestedChild;
  };

  resetFields = (fields) => {
    let resetValue = { customFields: {}, defaultFields: {} };
    fields?.map((el) => {
      if (el?.isCustom) {
        resetValue = {
          ...resetValue,
          customFields: { ...resetValue?.customFields, [el?.name]: null }
        };
      } else {
        resetValue = {
          ...resetValue,
          defaultFields: { ...resetValue?.defaultFields, [el?.name]: null }
        };
      }
    });
    const formFields = JSON.parse(
      this.props.state.selectedFormTemplate?.fieldDetails || '{}'
    );
    let updatedFormFields = {};
    if (!isEmpty(formFields) && !isEmpty(resetValue)) {
      const formFieldsKeys = Object.keys({
        ...resetValue.customFields,
        ...resetValue.defaultFields
      });
      const updatedFieldLayout = formFields?.layout?.map((el) => {
        const containField = formFieldsKeys?.includes(
          el?.field?.fieldProps?.name
        )
          ? null
          : el?.field?.fieldProps?.defaultValue;
        return {
          ...el,
          field: {
            ...el?.field,
            fieldProps: {
              ...el?.field?.fieldProps,
              defaultValue: containField,
              selectedValue: containField
            }
          }
        };
      });
      updatedFormFields = {
        ...this.props.state.selectedFormTemplate,
        fieldDetails: JSON.stringify({ layout: updatedFieldLayout })
      };
    }
    return { resetValue, updatedFormFields };
  };

  updateField = (key, field) => {
    const currentField = this.state?.ticketMeta?.find(
      (attr) => attr?.name === key
    );
    const allChilds = this.getNestedChilds(
      currentField,
      this.state?.ticketMeta
    );
    let req = { ...this.props.state.ticket.requester };
    if (key === 'client') {
      req = null;
    }
    let updatedPropeties = this.props.state;

    let defaultFields = {};

    if (!isEmpty(allChilds)) {
      const { resetValue, updatedFormFields } = this.resetFields(allChilds);
      if (!isEmpty(resetValue.customFields)) {
        updatedPropeties = {
          ...updatedPropeties,
          formFieldData: {
            ...this.props.state.formFieldData,
            customFields: {
              ...this.props.state.formFieldData.customFields,
              ...resetValue.customFields
            }
          }
        };
      }
      if (!isEmpty(updatedFormFields)) {
        updatedPropeties = {
          ...updatedPropeties,
          selectedFormTemplate: updatedFormFields
        };
      }

      defaultFields = resetValue?.defaultFields || {};
    }

    this.props.setState({
      ...updatedPropeties,
      ticket: {
        ...this.props.state.ticket,
        requester: req,
        [key]: field,
        ...defaultFields
      }
    });
  };

  updateFormField = (key, field) => {
    this.props.setState({
      ...this.props.state,
      formFieldData: {
        ...this.props.state.formFieldData,
        [key]: field
      }
    });
  };

  updateProperties = (properties) => {
    this.props.setState({
      ...this.props.state,
      ticket: {
        ...this.props.state.ticket,
        ...properties
      }
    });
  };

  cancel = () => {
    const { actions, tab } = this.props;
    actions.closeTab(tab);
  };

  setEditorReference = (ref) => {
    this.editorReferece = ref;
  };

  setEditMode = () => {
    const { editMode } = this.props.state;
    this.props.setState({ ...this.props.state, editMode: !editMode });
  };

  handleTemplateChange = (val) => {
    let formKeys = {};

    // formInputKeys has static data, instead need to get keys from getAllFields api
    formInputKeys.forEach((key) => {
      formKeys = {
        ...formKeys,
        [key]: null
      };
    });
    if (!isEmpty(this.props.state.formFieldData.customFields)) {
      for (const key in this.props.state.formFieldData.customFields) {
        formKeys = {
          ...formKeys,
          customFields: {
            ...formKeys.customFields,
            [key]: null
          }
        };
      }
    }
    this.props.setState({
      ...this.props.state,
      selectedFormTemplate: val,
      formFieldData: formKeys
    });
  };

  updateTemplate = (obj) => {
    const updatedTemplate = cloneDeep(this.props.state.template);
    this.props.setState({
      ...this.props.state,
      template: { ...updatedTemplate, ...obj }
    });
  };

  updateSelectedFormTemplate = (updatedTemplate) => {
    this.props.setState({
      ...this.props.state,
      selectedFormTemplate: updatedTemplate
    });
  };

  handleFileAttachments = (files) => {
    const formData = new FormData();
    // formData.append('files', files);
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });
    formData.append('module', 'TICKET_SCHEDULER_ATTACHMENT');
    // if (template?.id) {
    //   formData.append('notificationTemplateId', template.id);
    // }
    // for (const property in uploadParams) {
    //   formData.append(property, uploadParams[property]);
    // }
    this.props.setState({ ...this.props.state, isUploading: true });
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(`${envConfig.fileRoot}/upload`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((list) => {
        const updatedTemplate = cloneDeep(this.props.state.template);
        const updatedList = [...updatedTemplate?.attachments, ...list.data];
        updatedTemplate.attachments = updatedList;
        this.props.setState({
          ...this.props.state,
          template: updatedTemplate,
          isUploading: false
        });
      })
      .catch((err) => {
        console.error('Error:', err);
        this.props.setState({ ...this.props.state, isUploading: false });
      });
  };

  handleAttachmentsDeletion = (fileName) => {
    const updatedTemplate = cloneDeep(this.props.state.template);
    const updatedList = cloneDeep(updatedTemplate?.attachments).filter(
      (item) => item.fileName !== fileName
    );
    updatedTemplate.attachments = updatedList;
    this.props.setState({ ...this.props.state, template: updatedTemplate });
  };

  getDefaultValue = (fieldValue, fieldName) => {
    switch (fieldName) {
      case 'techGroup':
        return fieldValue
          ? {
              ...fieldValue,
              name: fieldValue.name,
              label: fieldValue.name,
              value: fieldValue.name
            }
          : '';
      case 'technician':
        return fieldValue
          ? {
              ...fieldValue,
              name: `${fieldValue.firstName} ${fieldValue.lastName}`,
              label: `${fieldValue.firstName} ${fieldValue.lastName}`,
              value: `${fieldValue.firstName} ${fieldValue.lastName}`
            }
          : '';
      default:
        return fieldValue
          ? { name: fieldValue, label: fieldValue, value: fieldValue }
          : '';
    }
  };

  getCellProps = (col) => {
    const { entitiesMeta } = this.props;
    const allEntityFields = getEntityAttributes(
      entitiesMeta,
      ENTITY_MAP.ticket
    );
    return {
      type: getCellType(col),
      accessor: getAccessor(col),
      editable: true,
      actions: { save: this.updateProperties },
      field: col,
      parentField: isDependantField(col.name)
        ? allEntityFields.find((el) => el.name === getParentField(col.name))
        : col,
      dependantField: isDependantField(col.name)
        ? col
        : allEntityFields.find((el) => el.name === getDependantField(col.name))
    };
  };

  clearTechnician = () => {
    const updatedTicket = { ...this.props.state.ticket };
    delete updatedTicket.technician;
    this.props.setState({
      ...this.props.state,
      ticket: updatedTicket
    });
  };

  renderTechCell = () => {
    const { entitiesMeta } = this.props;
    const allEntityFields = getEntityAttributes(
      entitiesMeta,
      ENTITY_MAP.ticket
    );
    const field = allEntityFields.find((el) => el.name === 'technician');
    const { ticket } = this.props.state;
    const fieldValue = ticket['technician'];
    const defaultValue = this.getDefaultValue(fieldValue, 'technician');
    // const Tag = getTag(field);
    const allProps = this.getCellProps(field);

    return (
      <TechCell className="flex center full-height ml8 technician-select">
        <Avatar
          customer={!ticket.technician && !ticket.techGroup}
          initials={
            ticket.technician
              ? `${ticket?.technician?.firstName?.[0]}${ticket?.technician?.lastName?.[0]}`
              : ticket?.techGroup?.name?.[0]
          }
        />
        <div className="ml8 full-width">
          <DualCell
            defaultValue={defaultValue}
            updateSelection={this.updateProperties}
            _ticket={ticket}
            field={field}
            params={allProps}
            isClearable
          />
        </div>
        <div className="pointer closeIcon" onClick={this.clearTechnician}>
          <SVGIcon name="Close" size="sm" />
        </div>
      </TechCell>
    );
  };

  render() {
    const { intl, toolbarHidden, ReadOnly, children, errors } = this.props;
    const {
      ticket,
      selectedFormTemplate,
      submitActionLoading,
      template,
      isUploading
    } = this.props.state;
    const name =
      (ticket?.requester?.firstName || '') +
      (ticket?.requester?.lastName || '');
    return (
      <Wrapper>
        <div className="mt-20 ml-20 flex source center">
          <AccessControl
            productToCheck="MSP"
            roleToCheck="client.view"
            render={
              <div className="fx keyval">
                <ClientSelect
                  fetchBefore
                  updateField={this.updateField}
                  property="accountId"
                  value="client"
                  selectedValue={ticket.client}
                  defaultValue={
                    ticket.client?.name && ticket.client?.label
                      ? [
                          {
                            name: ticket.client?.name,
                            label: ticket.client?.name
                          }
                        ]
                      : []
                  }
                  errors={errors?.['client.accountId']?.[0]}
                />
              </div>
            }
          />
          <AccessControl
            roleToCheck={{
              operator: 'OR',
              roles: ['site.view', 'companySite.view']
            }}
            render={
              <SiteSelect
                accountId={ticket.client?.accountId}
                updateSite={(val) => {
                  this.updateField('site', {
                    id: val.id,
                    name: val.name
                  });
                }}
                site={ticket.site}
                errors={errors?.['site.id']?.[0]}
                hideLabel
                icon
                roundedIcon
              />
            }
          />
          <AccessControl
            productToCheck={COMMON_CONSTANTS.IT}
            roleToCheck="department.view"
            render={
              <div>
                <DepartmentSelect
                  onChange={(val) => {
                    if (val) {
                      this.updateField('department', {
                        businessFunctionId: val.value,
                        name: val.name
                      });
                    } else {
                      this.updateField('department', null);
                    }
                  }}
                  department={ticket.department}
                  showIcon
                />
              </div>
            }
          />
          <div className="fx keyval">
            <UserSelect
              fetchBefore
              client={ticket.client}
              site={ticket.site}
              department={ticket.department}
              updateField={this.updateField}
              property="userId"
              field="requester"
              value={ticket.requester}
              defaultValue={name ? [{ name: name, label: name }] : []}
              errors={errors?.['requester.userId']?.[0]}
              sortList
              isClearable
            />
          </div>
          <Query
            query={GET_PUBLISHED_TICKET_FORMS}
            fetchPolicy="cache-and-network"
          >
            {({ loading, error, data }) => {
              if (loading) return <Spinner size="small" color="inkLightest" />;
              if (error) return `Error! ${error.message}`;

              let forms = data?.getPublishedTicketForms || [];
              forms = forms.map((el) => {
                return {
                  ...el,
                  value: el.formName,
                  label: el.formName,
                  name: el.formName
                };
              });

              forms = sortBy(forms, (el) => {
                return el?.name.toString().toLowerCase();
              });

              const currentFormId = selectedFormTemplate?.formId;
              const selectedForm = forms?.find(
                (el) => el.formId === currentFormId
              );

              return (
                <div
                  spacing="tight"
                  id="empDesigSelect"
                  className="formTemplates flex center select-container"
                >
                  <Avatar
                    name="form"
                    source={`${envConfig.imageRoot}svg/tasks_white.svg`}
                  />
                  <div className="full-width ml8">
                    <Select
                      isClearable
                      value={selectedForm}
                      onChange={this.handleTemplateChange}
                      placeholder={getTranslatedText(
                        intl,
                        'ticket.new.pl.temp'
                      )}
                      name="forms"
                      options={forms}
                      classNamePrefix="value_selector"
                      components={{
                        IndicatorSeparator,
                        DropdownIndicator
                      }}
                      formatGroupLabel={formatGroupLabel}
                      menuPlacement="auto"
                      closeMenuOnScroll={(e) => {
                        return (
                          e.target &&
                          e.target.classList &&
                          !(e.target.classList.value.indexOf('menu-list') > -1)
                        );
                      }}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />
                  </div>
                </div>
              );
            }}
          </Query>
          <AccessControl
            roleToCheck="employees.view"
            render={<Field>{this.renderTechCell()}</Field>}
          />
        </div>

        <div className="ta-l pl40">
          <TextField
            id="ticketSubject"
            value={ticket.subject}
            onChange={(val) => {
              this.updateField('subject', val);
            }}
            autoComplete="off"
            placeholder={getTranslatedText(intl, 'ticket.new.pl.subject')}
            type="text"
            customClassName="Header-Input"
            error={errors?.subject?.[0]}
            maxLength={TEXT_LENGTH.size_5}
            noborder
            fontSize="fontLarge"
          />
        </div>
        <EditorHolder className="editor-holder">
          <EmailEditor
            template={template}
            updateTemplate={this.updateTemplate}
            handleFileAttachments={this.handleFileAttachments}
            handleAttachmentsDeletion={this.handleAttachmentsDeletion}
            placeholder={getTranslatedText(intl, 'ticket.new.pl.desc')}
            module="TICKET"
            details={
              ticket?.client?.accountId
                ? {
                    operation: 'CREATE',
                    clientId: ticket.client?.accountId
                  }
                : {
                    operation: 'CREATE'
                  }
            }
            isUploading={isUploading}
          />
        </EditorHolder>

        {!isEmpty(selectedFormTemplate) ? (
          <div
            className={!selectedFormTemplate ? '' : 'custom-form-layout-card'}
          >
            <CustomFormTemplate
              ticket={{ ...ticket, ...this.props.state.formFieldData }}
              selectedFormTemplate={selectedFormTemplate}
              updateField={this.updateFormField}
              updateSelectedFormTemplate={this.updateSelectedFormTemplate}
              contentHeight
            />
          </div>
        ) : (
          ''
        )}
      </Wrapper>
    );
  }
}

export default withErrorBoundary(injectIntl(CreateTicketForm));
